import { useEffect, useState } from "react";
import { NAV_LINKS, PHONE, PHONE_HREF, scrollToId } from "@/lib/site";

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-2.5">
    <span
      className={`flex h-10 w-10 items-center justify-center font-display text-xl font-semibold ${
        dark ? "bg-amber text-white" : "bg-navy text-[#e8a33d]"
      }`}
      style={{ borderRadius: 4 }}
    >
      S
    </span>
    <span className="leading-tight text-left">
      <span className={`block font-display text-[17px] font-semibold ${dark ? "text-white" : "text-navy"}`}>
        SundaySea
      </span>
      <span className={`block text-[9px] uppercase tracking-[0.32em] ${dark ? "text-white/50" : "text-[#8a97a5]"}`}>
        Painting Co.
      </span>
    </span>
  </span>
);

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-shadow duration-300 ${
        scrolled ? "bg-white shadow-[0_1px_0_#e6e6e1]" : "bg-white"
      }`}
    >
      <div className="mx-auto flex h-20 max-w-[1200px] items-center justify-between px-5 md:px-8">
        <button data-testid="nav-logo" onClick={() => (window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" }))}>
          <Logo />
        </button>

        <nav className="hidden items-center gap-8 lg:flex">
          {NAV_LINKS.map(([label, hash, tid]) => (
            <button
              key={hash}
              data-testid={tid}
              onClick={() => scrollToId(hash)}
              className="text-[15px] text-[#445260] transition-colors duration-300 hover:text-amber"
            >
              {label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-5">
          <a href={PHONE_HREF} data-testid="header-phone-link" className="hidden items-center gap-2 text-[15px] font-medium text-navy md:flex">
            <svg viewBox="0 0 24 24" className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3-8.7A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .4 2 .7 2.8a2 2 0 0 1-.4 2.1L8.1 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.9.6 2.8.7a2 2 0 0 1 1.7 2z" />
            </svg>
            {PHONE}
          </a>
          <button data-testid="header-cta-button" onClick={() => scrollToId("#contact")} className="btn-amber !h-11">
            Free Quote
          </button>
        </div>
      </div>
    </header>
  );
}
